import {CustomerReportContext} from '../context'
import {KTCard} from '../../../_metronic/helpers'
import useGetCustomerGroupReport from '../hooks/useGetCustomerGroupReport'
import useGetCustomerTypeReport from '../hooks/useGetCustomerTypeReport'
import CustomerGroupReportTable from '../sections/table/CustomerGroupReportTable'
import CustomerTypeReportTable from '../sections/table/CustomerTypeReportTable'
import {CustomerReportsHeader} from '../sections/header/CustomerReportsHeader'
import useGetCustomerGroupDropdown from '../hooks/useGetCustomerGroupDropdown'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'

function CustomerReport() {
  const {
    reportData: customerGroupData,
    isLoading: isCustomerGroupLoading,
    filters: customerGroupFilters,
    onSortingChange: onCustomerGroupSortingChange,
    handleCustomerGroupReportDateChange,
    onChangeCustomerGroupFilter,
  } = useGetCustomerGroupReport()

  const {
    reportData: customerTypeData,
    isLoading: isCustomerTypeLoading,
    filters: customerTypeFilters,
    onSortingChange: onCustomerTypeSortingChange,
    handleCustomerTypeReportDateChange,
  } = useGetCustomerTypeReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('customer_group')

  const {
    entityPerformanceChartData: customerTypeEntityPerformanceChartData,
    isLoading: isCustomerTypeEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange: onCustomerTypeEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange: onCustomerTypeEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange: onCustomerTypeEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters: customerTypeEntityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('customer_type')

  const {
    entityPerformanceChartData: allEntityPerformanceChartData,
    isLoading: isAllEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange: onAllEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange: onAllEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange: onAllEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters: allEntityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('all')

  const {customerGroups, isLoading: isCustomerGroupsLoading} = useGetCustomerGroupDropdown()

  const contextValue = {
    customerGroupData,
    isCustomerGroupLoading,
    customerGroupFilters,
    onCustomerGroupSortingChange,
    handleCustomerGroupReportDateChange,
    onChangeCustomerGroupFilter,

    customerTypeData,
    isCustomerTypeLoading,
    customerTypeFilters,
    onCustomerTypeSortingChange,
    handleCustomerTypeReportDateChange,

    customerGroups,
    isCustomerGroupsLoading,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    customerTypeEntityPerformanceChartData,
    isCustomerTypeEntityPerformanceChartDataLoading,
    onCustomerTypeEntityPerformanceChartIdChange,
    onCustomerTypeEntityPerformanceChartViewChange,
    onCustomerTypeEntityPerformanceChartDateRangeChange,
    customerTypeEntityPerformanceChartFilters,

    allEntityPerformanceChartData,
    isAllEntityPerformanceChartDataLoading,
    onAllEntityPerformanceChartIdChange,
    onAllEntityPerformanceChartViewChange,
    onAllEntityPerformanceChartDateRangeChange,
    allEntityPerformanceChartFilters,
  }

  return (
    <KTCard>
      <CustomerReportContext.Provider value={contextValue}>
        <CustomerReportsHeader />
        <CustomerGroupReportTable />
        <CustomerTypeReportTable />
      </CustomerReportContext.Provider>
    </KTCard>
  )
}

export default CustomerReport
